import { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { Task } from "~/api/Api";
import { PAGE_TITLES } from "~/configs/pageTitles";
import { usePageTitle } from "~/hooks/usePageTitle";
import { routes } from "~/router";

import styles from "./BrandLinksPage.module.scss";
import LinksTasksPage, {
  InternalLinkCell,
  StatusBadge,
  formatPercent,
} from "./LinksTasksPage";

const BrandLinksPage = () => {
  usePageTitle(PAGE_TITLES.foundationLinks);
  const { id: siteId } = useParams();

  if (!siteId) {
    throw Error("No site id provided");
  }

  const columns = useMemo<ColumnDef<Task>[]>(
    () => [
      {
        accessorKey: "status",
        header: "Status",
        enableSorting: false,
        cell: (info) => (
          <StatusBadge status={info.getValue() as string} styles={styles} />
        ),
      },
      {
        accessorKey: "link_title",
        header: "Site",
        cell: (info) => {
          const task = info.row.original;

          return (
            <InternalLinkCell
              to={routes.site.links.brandTask({
                id: siteId,
                taskId: task.id,
              })}
              domain={task.link_domain}
              styles={styles}
            >
              {task.link_title || "No title"}
            </InternalLinkCell>
          );
        },
      },
      {
        accessorKey: "link_domain",
        header: "Domain",
      },
      {
        accessorKey: "category",
        header: "Category",
        cell: (info) => (info.getValue() as string) || "-",
      },
      {
        accessorKey: "probability",
        header: "Relevance",
        cell: (info) => formatPercent(info.getValue() as number | null),
      },
    ],
    [siteId],
  );

  return (
    <LinksTasksPage
      title={PAGE_TITLES.foundationLinks}
      description="Foundation opportunities help build the core link signals that reinforce your website's credibility and support sustainable SEO and AI search growth."
      siteId={siteId}
      taskType="BrandLink"
      dfyLink={{
        label: "Done-For-You Foundation Links",
        to: routes.services.brandLinks(),
      }}
      searchRansackKey="link_domain_or_link_title_or_category_i_cont"
      columns={columns}
      styles={styles}
    />
  );
};

export default BrandLinksPage;
